export default __webpack_public_path__ + "static/media/dimitris.f38aec4f.jpg";